import { useStyleConfigV2 } from '@tectonic/elemason-components';
import { useEffect, type FC } from 'react';
import { Icon } from '../../components';
import { useActionDispatch, useSharedLocalState } from '../../hooks';
import { useHaloScript } from '../../hooks/useHaloScript';

import type { ElemasonLegendWidget } from '@tectonic/types';

interface ElemasonLegendWidgetProps {
  widget: ElemasonLegendWidget;
}

const LegendWidget: FC<ElemasonLegendWidgetProps> = ({
  widget: { data, config, actions },
}) => {
  const id = useHaloScript(data?.id);
  const dispatch = useActionDispatch();
  const legend = useHaloScript(data?.legend);
  const stateKey = useHaloScript(data?.stateKey);
  const isDefault = useHaloScript(data?.isDefault);
  const [style, className] = useStyleConfigV2(config?.icon);
  const { sharedState, setSharedState } = useSharedLocalState(stateKey!);
  const currentSymbol =
    id === sharedState ? data?.activeIcon : data?.inActiveIcon;

  useEffect(() => {
    if (isDefault) {
      setSharedState(id);
    }
  }, [isDefault, setSharedState]);

  const onClick = () => {
    setSharedState(id);
    document.getElementById(id!)?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
    actions?.onClick.forEach((action) => {
      dispatch(action);
    });
  };

  return (
    <Icon
      style={{
        ...style,
        position: 'absolute',
        top: `${legend!.y * 100}%`,
        left: `${legend!.x * 100}%`,
      }}
      onClick={onClick}
      className={className}
      config={config?.icon}
      symbol={currentSymbol!}
    />
  );
};

export { LegendWidget };
